import { createContext, useContext } from 'react';

import type { AdaptiveLearningPlan, LearningBlock, TimeCommitment } from 'bundles/course-frame/adaptive-learning/types';
import { DEFAULT_TIME_COMMITMENT } from 'bundles/course-frame/adaptive-learning/types';

export type AdaptiveLearningContextType = {
  show: boolean;
  setShow: (show: boolean) => void;
  adaptivePlan?: AdaptiveLearningPlan;
  timeCommitment: TimeCommitment;
  getLearningBlock: (itemId: string) => LearningBlock | undefined;
  getProgress: (itemId: string) => number;
  updateLearningPath: (options: { timeCommitment: TimeCommitment }) => void;
};

export const AdaptiveLearningContext = createContext<AdaptiveLearningContextType>({
  show: false,
  setShow: () => undefined,
  timeCommitment: DEFAULT_TIME_COMMITMENT,
  getLearningBlock: () => undefined,
  getProgress: () => 0,
  updateLearningPath: () => undefined,
});

export const useAdaptiveLearningContext = () => useContext(AdaptiveLearningContext);
